<div id="checkout-step-2" class="checkout-accordion mb-3" [class.checkout-accordion--open]="checkoutStep === 2">
  <div class="checkout-accordion__header" (click)="headerClick.emit()">
    <span class="ca-badge" [class.ca-badge--done]="checkoutStep > 2">{{ checkoutStep > 2 ? '✓' : '2' }}</span>
    <span class="ca-title">{{'PRODUCTS.DELIVERY_TIME' | translate}}</span>
    <span class="ca-summary" *ngIf="checkoutStep !== 2 && deliveryMode">{{ deliveryModeSummary }}</span>
    <i class="fas ca-chevron"
       [class.fa-chevron-up]="checkoutStep === 2"
       [class.fa-chevron-down]="checkoutStep !== 2"></i>
  </div>

  <div class="checkout-accordion__body" *ngIf="checkoutStep === 2">
    <div class="dmode-list">

      <!-- Option 1 : Retrait / livraison locale -->
      <div class="dmode-card" [class.dmode-card--open]="deliveryMode === 'pickup'">
        <div class="dmode-header" (click)="deliveryModeToggle.emit('pickup')">
          <span class="dmode-icon">🏠</span>
          <div class="dmode-header-text">
            <span class="dmode-title">{{'PRODUCTS.DELIVERY_PICKUP' | translate}}</span>
            <span class="dmode-subtitle">
              <ng-container *ngIf="deliveryMode !== 'pickup'">{{'PRODUCTS.HOW_TO_GET_DELIVERED_FROM_LBV' | translate}}</ng-container>
              <ng-container *ngIf="deliveryMode === 'pickup' && !pickupSubMode">Choisissez votre mode de retrait</ng-container>
              <ng-container *ngIf="deliveryMode === 'pickup' && pickupSubMode === 'courier'">🛵 Livraison par coursier</ng-container>
              <ng-container *ngIf="deliveryMode === 'pickup' && pickupSubMode === 'store'">🏪 Récupération au magasin</ng-container>
            </span>
          </div>
          <i class="fas dmode-chevron"
             [class.fa-chevron-down]="deliveryMode !== 'pickup'"
             [class.fa-chevron-up]="deliveryMode === 'pickup'"></i>
        </div>

        <div class="dmode-body" *ngIf="deliveryMode === 'pickup'" (click)="$event.stopPropagation()">
          <div class="dmode-sub-list">

            <!-- Sub-option : Coursier -->
            <div class="dmode-sub-card" [class.dmode-sub-card--open]="pickupSubMode === 'courier'">
              <div class="dmode-sub-header" (click)="pickupSubModeToggle.emit('courier')">
                <span class="dmode-sub-icon">🛵</span>
                <div class="dmode-sub-header-text">
                  <span class="dmode-sub-title">Livraison à domicile par coursier</span>
                  <span class="dmode-sub-subtitle" *ngIf="pickupSubMode !== 'courier'">Payé directement au livreur à la réception</span>
                </div>
                <i class="fas dmode-chevron-sm"
                   [class.fa-chevron-down]="pickupSubMode !== 'courier'"
                   [class.fa-chevron-up]="pickupSubMode === 'courier'"></i>
              </div>
              <div class="dmode-sub-body" *ngIf="pickupSubMode === 'courier'">
                <p class="dmode-sub-desc">
                  Le vendeur vous envoie votre commande via un livreur indépendant.
                  Vous payez directement le livreur à la réception.
                  Cette somme ne transite pas par le site.
                </p>
                <p class="courier-rates">
                  <strong>Tarifs indicatifs :</strong>
                  Libreville <strong>2 000 FCFA</strong> —
                  Akanda, Owendo &amp; PK <strong>2 500 FCFA</strong> —
                  Port-Gentil <strong>4 500 FCFA</strong> —
                  Franceville <strong>5 000 FCFA</strong>
                </p>
                <div class="courier-agreement" (click)="courierAgreementChange.emit(!courierAgreementChecked)">
                  <div class="courier-checkbox-label">
                    <span class="courier-checkbox-icon">{{ courierAgreementChecked ? '☑' : '☐' }}</span>
                    <span>Je m'engage à payer la somme réclamée par le livreur à la réception de ma commande (entre 2 000 et 5 000 FCFA).</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sub-option : Magasin -->
            <div class="dmode-sub-card" [class.dmode-sub-card--open]="pickupSubMode === 'store'">
              <div class="dmode-sub-header" (click)="pickupSubModeToggle.emit('store')">
                <span class="dmode-sub-icon">🏪</span>
                <div class="dmode-sub-header-text">
                  <span class="dmode-sub-title">Récupération au magasin</span>
                  <span class="dmode-sub-subtitle" *ngIf="pickupSubMode !== 'store'">Venez chercher votre commande à Libreville</span>
                </div>
                <i class="fas dmode-chevron-sm"
                   [class.fa-chevron-down]="pickupSubMode !== 'store'"
                   [class.fa-chevron-up]="pickupSubMode === 'store'"></i>
              </div>
              <div class="dmode-sub-body" *ngIf="pickupSubMode === 'store'">
                <p class="dmode-sub-desc">Venez récupérer votre commande directement à notre boutique à Libreville.</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Option 2 : Expédition internationale -->
      <div class="dmode-card" [class.dmode-card--open]="deliveryMode === 'shipping'">
        <div class="dmode-header" (click)="deliveryModeToggle.emit('shipping')">
          <span class="dmode-icon">✈️</span>
          <div class="dmode-header-text">
            <span class="dmode-title">{{'PRODUCTS.DELIVERY_SHIPPING' | translate}}</span>
            <span class="dmode-subtitle">
              <ng-container *ngIf="deliveryMode !== 'shipping'">DHL, FedEx — avec lien de suivi</ng-container>
              <ng-container *ngIf="deliveryMode === 'shipping' && isShippingAddressValid">✓ Adresse renseignée</ng-container>
              <ng-container *ngIf="deliveryMode === 'shipping' && !isShippingAddressValid">Renseignez votre adresse de livraison</ng-container>
            </span>
          </div>
          <i class="fas dmode-chevron"
             [class.fa-chevron-down]="deliveryMode !== 'shipping'"
             [class.fa-chevron-up]="deliveryMode === 'shipping'"></i>
        </div>

        <div class="dmode-body" *ngIf="deliveryMode === 'shipping'" (click)="$event.stopPropagation()">
          <p class="dmode-sub-desc">
            Votre commande sera expédiée <strong>dès réception de votre paiement</strong> via
            <strong>DHL</strong>, <strong>FedEx</strong> ou un autre transporteur.
            Vous recevrez un email avec le <strong>lien de suivi</strong> dès l'expédition.
          </p>
          <p class="dmode-note">
            <i class="fas fa-info-circle mr-1"></i>Pour les commandes dépassant 150 € (Union Européenne), des droits de douane peuvent être exigés à la réception selon votre pays. Ces frais ne sont pas inclus dans le montant de la commande.
          </p>
          <div class="shipping-address-form">
            <p class="shipping-address-title">
              <i class="fas fa-map-marker-alt mr-2"></i>Adresse de livraison
            </p>
            <div class="addr-row">
              <div class="addr-field">
                <label class="addr-label">Prénom <span class="required">*</span></label>
                <input type="text" class="addr-input" [(ngModel)]="shippingAddress.firstName"
                       placeholder="Prénom" autocomplete="given-name" (input)="shippingAddressChange.emit()">
              </div>
              <div class="addr-field">
                <label class="addr-label">Nom <span class="required">*</span></label>
                <input type="text" class="addr-input" [(ngModel)]="shippingAddress.lastName"
                       placeholder="Nom de famille" autocomplete="family-name" (input)="shippingAddressChange.emit()">
              </div>
            </div>
            <div class="addr-field">
              <label class="addr-label">Adresse <span class="required">*</span></label>
              <input type="text" class="addr-input" [(ngModel)]="shippingAddress.address1"
                     placeholder="Numéro et nom de rue" autocomplete="address-line1" (input)="shippingAddressChange.emit()">
            </div>
            <div class="addr-field">
              <label class="addr-label">Complément d'adresse</label>
              <input type="text" class="addr-input" [(ngModel)]="shippingAddress.address2"
                     placeholder="Appartement, bâtiment, etc. (optionnel)" autocomplete="address-line2" (input)="shippingAddressChange.emit()">
            </div>
            <div class="addr-row">
              <div class="addr-field addr-field--short">
                <label class="addr-label">Code postal <span class="required">*</span></label>
                <input type="text" class="addr-input" [(ngModel)]="shippingAddress.postalCode"
                       placeholder="75001" autocomplete="postal-code" (input)="shippingAddressChange.emit()">
              </div>
              <div class="addr-field">
                <label class="addr-label">Ville <span class="required">*</span></label>
                <input type="text" class="addr-input" [(ngModel)]="shippingAddress.city"
                       placeholder="Paris" autocomplete="address-level2" (input)="shippingAddressChange.emit()">
              </div>
            </div>
            <div class="addr-field">
              <label class="addr-label">Pays <span class="required">*</span></label>
              <input type="text" class="addr-input" [(ngModel)]="shippingAddress.country"
                     placeholder="France" autocomplete="country-name" (input)="shippingAddressChange.emit()">
            </div>
            <div class="addr-field">
              <label class="addr-label">Téléphone <span class="required">*</span></label>
              <input type="tel" class="addr-input" [(ngModel)]="shippingAddress.phone"
                     placeholder="+33 6 12 34 56 78" autocomplete="tel" (input)="shippingAddressChange.emit()">
            </div>
            <p class="addr-required-note"><span class="required">*</span> Champs obligatoires</p>
          </div>
        </div>
      </div>

    </div>

    <!-- Bouton suivant -->
    <div class="ca-next-bar">
      <button class="btn-step-next" (click)="next.emit()" [disabled]="!canGoToPayment">
        {{'PRODUCTS.PAYMENTS_MEANS' | translate}} <i class="fas fa-arrow-right ml-2"></i>
      </button>
    </div>
  </div>
</div>
